import {
    AGREEMENTS_ERROR,
    AGREEMENTS_FETCH_START,
    AGREEMENTS_FETCH_SUCCESS,
    AGREEMENTS_RESET,
    AgreementsAction
} from 'actions/agreements/AgreementsActionsTypes';
import { AgreementsState, AgreementsStatus } from 'reducers/agreements/AgreementsState';
import { Reducer } from 'redux';

const initialState: AgreementsState = {
    status: AgreementsStatus.Initial,
    agreements: [],
    loading: false
};

export const agreementsReducer: Reducer<AgreementsState, AgreementsAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case AGREEMENTS_RESET:
            return {
                ...initialState
            };

        case AGREEMENTS_ERROR:
            return {
                ...state,
                loading: false,
                status: AgreementsStatus.Error
            };

        // Fetch
        case AGREEMENTS_FETCH_START:
            return {
                ...state,
                loading: true,
                status: AgreementsStatus.FetchStart
            };
        case AGREEMENTS_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                agreements: action.payload.agreements,
                status: AgreementsStatus.FetchSuccess
            };

        default:
            return state;
    }
};
